import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/** POST `/crm/customer-order/{id}/approve`。body：`updatedAt`（record）。 */
export async function approveCustomerOrder(id, payload = {}) {
  const { data: raw } = await request.post(
    `/crm/customer-order/${id}/approve`,
    keysToSnake(payload),
  );
  return parseVer4DetailResponse(raw);
}
